import api from '@/api'

const state = {
  songs: []
}

const getters = {
  getSongs: (state) => state.songs
}

const mutations = {
  SET_SONGS (state, songs) {
    state.songs = songs
  },
  ADD_SONG (state, song) {
    // TODO
  },
  REMOVE_SONG (state, song) {
    // TODO
  }
}

const actions = {
  async getSongs ({ commit }) {
    try {
      const response = await api.backend.song.getSongs()
      commit('SET_SONGS', response.data)
    } catch (e) {
      console.error(e)
    }
  },

  async addSong ({ commit, dispatch }, song) {
    try {
      const response = await api.backend.song.addSong(song)
      console.log(response)
      // commit('ADD_SONG', song)
      dispatch('getSongs')
    } catch (e) {
      console.error(e)
    }
  },

  async removeSong ({ commit, dispatch }, song) {
    try {
      const response = await api.backend.song.removeSong(song)
      console.log(response)
      // commit('REMOVE_SONG', song)
      dispatch('getSongs')
    } catch (e) {
      console.error(e)
    }
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
